export default __webpack_public_path__ + "static/media/btn-right-on@3x.36792563.png";